import * as actionType from './type';

const INITIAL_STATE = {
    allPermissionTypes: [],
    allRoleTypes: [],
}

export default function(state = INITIAL_STATE, action) {
    switch(action.type) {
        case actionType.RECEIVED_ALL_PERMISSION_TYPE: {
            return {
                ...state,
                allPermissionTypes: action?.payload
              }
        }

        case actionType.RECEIVED_ALL_ROLES: {
            return {
                ...state,
                allRoleTypes: action?.payload
              }
        }

        default: 
            return state;
    }
}